import { Col, Form, Input, Row } from "antd";
import { useForm } from "antd/lib/form/Form";
import _ from "lodash";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { DraggableModal } from "../../../../components/DraggableModal";
import { Contact, EntCompany } from "../../../../models/chemicalization/company";
import { ContactItems } from "./ContactItems";
import modal from "antd/es/modal";

enum FormField {
  id,
  companyName,
  phone,
  contacts,
}

interface IProps {
  show: boolean;
  company: EntCompany;
  onHide: () => void;
  onSubmit: (pos: EntCompany) => Promise<boolean>;
}

export const AddCompany = (props: IProps) => {
  const { t } = useTranslation();
  const [ form ] = useForm();
  const [ loading, setLoading ] = useState<boolean>(false);
  const [ contacts, setContacts ] = useState<Contact[] | null>(null);

  useEffect(() => {
	if (props.show) setFieldsFromEntity();
  }, [ props.show ]);

  const setFieldsFromEntity = (): void => {
	setContacts(props.company.contacts)
	form.setFields([
	  { name: FormField.companyName, value: props.company.companyName },
	]);
	if (props.company.contacts !== null) {
	  setContacts(props.company.contacts)
	}
  }


  const setEntityFromFields = (): EntCompany => {
	let res = _.cloneDeep(props.company);
	res.companyName = form.getFieldValue(FormField.companyName);
	if (contacts) {
	  res.contacts = contacts;
	}
	return res;
  };

  const hideModal = () => {
	props.onHide();
	setContacts(null)
  }

  const handleSubmit = async () => {
	setLoading(true);
	try {
	  await form.validateFields();
	  const data = setEntityFromFields();
	  const { contacts } = data;

	  if (!contacts || contacts.length === 0) {
		modal.error({
		  title: t('msg.error'),
		  content: t('Добавьте хотя бы одного контакта.')
		});
		return;
	  }

	  const invalidRegisters = contacts.filter(
		(contacts: Contact) => contacts.contactName == null || contacts.phone == null || contacts.email == null
	  );

	  if (invalidRegisters.length > 0) {
		modal.error({
		  title: t('msg.error'),
		  content: t('Заполните все поля для каждого контакта.')
		});
		return;
	  }

	  const result = await props.onSubmit(data);
	  if (result) hideModal();
	} catch (error: any) {
	  modal.error({
		title: t('msg.error'),
		content: error.message || t('msg.unexpected_error')
	  });
	} finally {
	  setLoading(false);
	}
  };

  return (
	<DraggableModal
	  title={
		props.company.id === null
		  ? t("general.add")
		  : t("general.edit")
	  }
	  visible={ props.show }
	  onCancel={ props.onHide }
	  onSubmit={ handleSubmit }
	  submitLoading={ loading }

	  width={ 800 }
	>
	  <Form
		initialValues={ { remember: true } }
		autoComplete="off"
		layout="vertical"
		form={ form }>
		<Row style={ { margin: 0 } } gutter={ 12 }>
		  <Col className="gutter-row" span={ 12 }>
			<Form.Item
			  label={ t("titles.company") }
			  name={ FormField.companyName }
			  rules={ [ { required: true, message: t("msg.fill_in_the_field") } ] }
			>
			  <Input type="text"/>
			</Form.Item>
		  </Col>
		  <Col className="gutter-row" span={ 24 }>
			<ContactItems contacts={ contacts } setContacts={ setContacts }/>
		  </Col>
		</Row>
	  </Form>
	</DraggableModal>
  );
};
